<div mat-dialog-title class="dialogContainer dialog-error">
  <label class="labelTitle">{{ data.title }}</label>
</div>

<mat-dialog-content class="dialogContent">
  <div class="dialogMessageText">{{ data.message }}</div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialogActionsBtns">
  <button mat-raised-button color="warn" type="button" (click)="onConfirmClick()">{{ okButtonLabel }}</button>
</mat-dialog-actions>
